import React, { useState } from "react";
import TopNav from "../TopNav";
import Notifications from "../Notifications";
import NavHeader2 from "../NavHeader2";
import Sidebar from "../Sidebar";
import BreadcrumTop from "../BreadcrumTop";
import { getToken } from "../../../utils/getToken";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { API_ROUTES } from "../../../utils/constants";
const TestModule = (props) => {
  const { isLoaded, capitalizeWords } = props;
  const [loading, setLoading] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [error, setError] = useState("");

  const navigate = useNavigate();
  const isValid = () => {
    if (!phoneNumber) {
      setError("Phone number is required");
      return false;
    }

    const phoneRegex = /^\+?\d{7,11}$/;

    if (!phoneRegex.test(phoneNumber)) {
      setError("Please enter a valid phone number");
      return false;
    }

    setError("");
    return true;
  };
  const handlePhoneNumberChange = (e) => {
    setError("");
    let value = e.target.value;

    if (!/^\+?\d*$/.test(value)) {
      return;
    }

    if (value.replace("+", "").length > 11) {
      return;
    }

    setPhoneNumber(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isValid()) return;

    const token = getToken();
    if (!token) {
      await Swal.fire({
        title: "Error",
        text: "Please log in first.",
        icon: "error",
      });
      navigate("/login");
      return;
    }

    setLoading(true);

    // Format phone number
    const phoneNumberToSend = phoneNumber.startsWith("0")
      ? `234${phoneNumber.slice(1)}`
      : `234${phoneNumber}`;

    try {
      const url = `${API_ROUTES.TEST_MODE}/${encodeURIComponent(
        phoneNumberToSend
      )}`;
      const response = await fetch(url, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();
      console.log("dataaa", data);
      const status = data.status || response.status;

      const messages = {
        200: data.message || "MSISDN deleted successfully.",
        400: data.message || "Bad Request. Please check your input.",
        401: data.message || "Unauthorized. Please log in again.",
        404: data.message || "MSISDN not found.",
        500: data.message || "Internal Server Error. Please try again later.",
      };

      switch (status) {
        case 200:
          await Swal.fire({
            title: "Success",
            text: messages[200],
            icon: "success",
          });
     
          break;

        case 401:
          await Swal.fire({
            title: "Unauthorized",
            text: messages[401],
            icon: "error",
          });

          break;

        default:
          await Swal.fire({
            title: "Error",
            text:
              messages[status] || data.message || "Unexpected error occurred.",
            icon: "error",
          });
      }
    } catch (error) {
      await Swal.fire({
        title: "Error",
        text: error.message || "Something went wrong.",
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div id="main-wrapper" className={isLoaded ? "show" : ""}>
      <TopNav />
      <Notifications />
      <NavHeader2 />
      <Sidebar />
      <div className="content-body mt--10">
        <div className="container-fluid pl-xs-0 pr-xs-0 pt-xs-0">
          <BreadcrumTop title="Test Mode" />

          <div className="row">
            <div className="d-flex justify-content-center align-items-center">
              <div className="col-xl-7 col-lg-10 col-md-10">
                <div className="card">
                  <div className="card-body">
                    <form onSubmit={handleSubmit}>
                      <div className="mb-2 row">
                        <div className="col-sm-10 offset-sm-2">
                          <p className="text-danger">
                            *All fields are compulsory
                          </p>
                          {/* {companyId} */}
                        </div>
                      </div>

                      <div className="mb-3 row">
                        <label className="col-sm-2 col-form-label">
                          Phone Number
                        </label>
                        <div className="col-sm-10">
                          <input
                            type="text"
                            name="phoneNumber"
                            value={phoneNumber}
                            onChange={handlePhoneNumberChange}
                            className="form-control"
                            placeholder="Enter phone number"
                            // required
                          />
                          {error && (
                            <p style={{ color: "red" }} className="mt-2 ms-2">
                              {error}
                            </p>
                          )}
                        </div>
                      </div>

                      <div className="mb-3 mt-4 row">
                        <div className="col-sm-12 d-flex justify-content-end">
                          <button
                            type="submit"
                            className="btn btn-primary m-1"
                            disabled={loading}
                          >
                            {loading ? (
                              <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>
                            ) : (
                              "Submit"
                            )}
                          </button>
                          {/* <Link
                            to="/marketers"
                            // state={{ rowData: { companyId: companyId } }}
                            state={{ rowData: { id: companyId } }}
                            className="btn btn-dark m-1"
                          >
                            Go Back
                          </Link> */}
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestModule;
